import React from 'react';
import { CrudStyles } from '../shared/Crud';
import { ROUTE_STATUS_DESCRIPTION, normalizeRouteStatusValue } from '../../services/routeService';
import { getRouteStatusMeta } from './routeStatusConfig';

const { StatusBadge } = CrudStyles;

/**
 * Badge de status de roteiro — mesmo layout/design de {@link ../Deliveries/DeliveryStatusBadge}.
 *
 * @param {{ state: string|object, compact?: boolean }} props
 */
export default function RouteStatusBadge({ state, compact = false }) {
    const meta = getRouteStatusMeta(state);
    const { label, colorToken, icon: Icon } = meta;
    const title =
        ROUTE_STATUS_DESCRIPTION[normalizeRouteStatusValue(meta.value)] || undefined;

    return (
        <StatusBadge
            as="span"
            style={{
                ...(compact ? {} : { minWidth: '11rem' }),
                textTransform: 'none',
            }}
            $active={meta.value === 'FINISHED'}
            data-color-token={colorToken}
            title={title}
        >
            {Icon ? <Icon /> : null}
            <span>{label}</span>
        </StatusBadge>
    );
}
